import { useMutation } from "@tanstack/react-query";

import type {
	PrepayCustomer,
	PrepayQuoteBol,
} from "~/shared/schemas/prepay-notification-schema.ts";
import { prepayNotificationResponseSchema } from "~/shared/schemas/prepay-notification-schema.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { postAndValidate } from "~/shared/services/api/fetch-client.ts";

/**
 * Phase 4a — Pre-pay tender success notification email (LTL BFF).
 * Fired AFTER `POST /payments/submit-payment` succeeds and BEFORE the
 * final tender call.
 */
export const useSendPrepayPaymentSuccessEmail = () => {
	return useMutation({
		mutationFn: async (body: PrepayQuoteBol) => {
			return await postAndValidate(
				apiRoutes.SENDCUSTOMERPREPAYMENTSUCCESS,
				body,
				prepayNotificationResponseSchema,
			);
		},
	});
};

/**
 * Phase 4b — Pre-pay tender failure notification email.
 * Fired when `POST /payments/submit-payment` fails.
 *
 * TODO: Spec routes this to the Emails API (env-specific base URL). This
 * codebase has no Emails API client; the call is currently sent through
 * the default LTL BFF base URL. Confirm with backend whether to:
 *   1. Migrate the endpoint behind the BFF (preferred), or
 *   2. Add an Emails API service config (env-config + fetch-client wiring).
 */
export const useSendPrepayTenderFailureEmail = () => {
	return useMutation({
		mutationFn: async (body: PrepayCustomer) => {
			return await postAndValidate(
				apiRoutes.SENDPREPAYTENDERFAILURE,
				body,
				prepayNotificationResponseSchema,
			);
		},
	});
};
